import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPasswordToggle]',
  standalone: true
})
export class PasswordToggleDirective {
  private isPasswordVisible = false;

  constructor(private el: ElementRef) {
    // Agregar el icono del ojo
    this.createToggleIcon();
  }

  private createToggleIcon() {
    const parent = this.el.nativeElement.parentElement;
    const icon = document.createElement('small');
    icon.className = 'material-symbols-outlined password-toggle-icon';
    icon.textContent = 'visibility_off';
    icon.style.color = '#9aa0a6';
    icon.style.fontSize = '16px';
    icon.style.cursor = 'pointer';
    icon.style.position = 'absolute';
    icon.style.right = '20px';
    icon.style.top = '50%';
    icon.style.transform = 'translateY(-50%)';
    icon.style.zIndex = '1';

    icon.addEventListener('click', () => {
      this.togglePasswordVisibility(icon);
    });

    parent.appendChild(icon);
  }

  private togglePasswordVisibility(icon: HTMLElement) {
    this.isPasswordVisible = !this.isPasswordVisible;
    this.el.nativeElement.type = this.isPasswordVisible ? 'text' : 'password';
    icon.textContent = this.isPasswordVisible ? 'visibility' : 'visibility_off';
  }
}